import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/app-router-context.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/hooks-client-context.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/server-inserted-html.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/components/PageContainer.tsx");
import(/* webpackMode: "eager" */ "/app/styles/events.scss");
import(/* webpackMode: "eager" */ "/app/app/teams/styles/teamPage.scss")